<template>
<div >
    <form @submit.prevent="contact"  v-if="!sended">

        <div class="row" v-if="!isAuthenticated">
            <div class="col-md-6 col-sm-6">
                <div class="form-group">
                    <input type="text" 
                        class="form-control" 
                        placeholder="Nombre" 
                        v-model="form.name" 
                        :class="{'is-invalid':validationErrors['data.name']}"
                        >
                    <div class="invalid-feedback">{{validationErrors['data.name']}}</div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6">
                <div class="form-group">
                    <input type="text" 
                        class="form-control" 
                        placeholder="Apellido" 
                        v-model="form.lastname" 
                        :class="{'is-invalid':validationErrors['data.lastname']}"
                        >
                    <div class="invalid-feedback">{{validationErrors['data.lastname']}}</div>
                </div>
            </div>
            
        </div>
        <div class="row" v-if="!isAuthenticated">
            <div class="col-md-6 col-sm-6">
                <div class="form-group">
                    <input type="text" 
                        class="form-control" 
                        placeholder="Email" 
                        v-model="form.email" 
                        :class="{'is-invalid':validationErrors['data.email']}"
                        >
                    <div class="invalid-feedback">{{validationErrors['data.email']}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <textarea rows="5" 
                        class="form-control" 
                        style="height:100px;"
                        placeholder="Ingrese su mensaje"
                        v-model="form.message" 
                        :class="{'is-invalid':validationErrors['data.message']}"
                        >
                    </textarea>
                    <div class="invalid-feedback">{{validationErrors['data.message']}}</div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <input type="text" id="verify_contact" class=" form-control" placeholder=" 3 + 1 =">
                </div>
            </div>
        </div> -->
        <input type="submit" class="btn_1" value="Enviar mensaje" v-if="!loading" >
        <div class="btn_1" v-else>
            Enviando...
        </div>
    </form>
    <div v-else class="alert alert-success text-center">
        <h5>Mensaje enviado correctamente</h5>
        <br>
        En instantes nos podremos en contacto contigo!!<br><br>Muchas gracias por contactarnos.
    </div>
</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

export default {
	name: "ContactForm",
	props:['subject'],
	data(){
		return{
			form:{
				name: '',
				lastname:'',
				email:'',
				message:'',
			},
			validationErrors:{},
            loading:false,
            sended:false,
		}
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
    },
    beforeMount(){
        if(this.isAuthenticated){
            this.form.name = this.loggedUser.name
            this.form.lastname = this.loggedUser.lastname
            this.form.email = this.loggedUser.email
        }
        
    },
	methods:{
        contact(){

            if(!this.loading){
				this.validationErrors = {};

                if(this.validate()){
                    
                    this.loading=true;
                    
                    var dataInput = {	
                        subject: this.subject,
                        name: this.form.name,			
                        lastname: this.form.lastname,			
                        email: this.form.email,			
                        message: this.form.message,			
                    };

                    if(this.$route.query.especiality){
                        dataInput.message += '<br>Especialidad buscada: '+this.$route.query.especiality
                    }
                    
                    if(this.$route.query.requestHours){
                        dataInput.message += '<br>Canal solicitado: '+this.$route.query.requestHours
                    }
                    

                    this.$apollo.mutate({
                        mutation: gql`mutation ( $data:ContactMessageInput! ){
                            createContactMessage( data: $data) {
                                id
                            }
                        }`,
                        variables: {
                            data: dataInput,
                        }
                    })
                    .then(() => {
                        this.loading=false;
                        this.form ={
                            name: '',
                            lastname:'',
                            email:'',
                            message:''
                        };
                        this.sended = true;
                        this.$emit('sended')
                    })
                    .catch(error => {
                        let { graphQLErrors } = error;
                        if (graphQLErrors[0].extensions.category === "validation") {
                            this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation);
                        }else{
                            this.validationErrors['general'] = 'Se ha producido un error';
                        }
                        this.loading=false;
                    })
                }
			}

        },
        validate(){
            let error = false;
            this.validationErrors = {};
            
            if( !this.form.name || this.form.name.length <=2 || this.form.name.length > 20 ){
                error=true;
                this.validationErrors['data.name'] = 'Ingrese su nombre';
            }
            if( !this.form.lastname || this.form.lastname.length <=2 || this.form.lastname.length > 20 ){
                error=true;
                this.validationErrors['data.lastname'] = 'Ingrese su apellido';
            }
            if( !this.form.email || !this.validateEmail(this.form.email) ){
                error=true;
                this.validationErrors['data.email'] = 'Ingrese un email válido';
			}
			
			if( !this.form.message || this.form.message.length<3  ){
                error=true;
                this.validationErrors['data.message'] = 'Ingrese su mensaje';
            }
            
            if( !error ){
                return true;
            }
            return false;
        },
        parseErrors(errors){
            let parsedErrors = [];
            Object.keys(errors).forEach( (key) => {
                parsedErrors[key] = errors[key][0];
                
            });
            return parsedErrors;
		},
		validateEmail(email) {
			var re = /\S+@\S+\.\S+/;
			return re.test(String(email).toLowerCase());
		},
	}
};
</script>

<style scoped>



</style>
